<template lang="pug">
b-modal#editPromoVoucherPaymentOption(
  ref="editPromoVoucherPaymentOption"
  :title="$t('ui.combine.edit_promo_voucher_payment_option')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.promotion_id')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="promotion_id"
        required
        type="text"
        :dirty="$v.promotion_id.$dirty"
        :error="$v.promotion_id.$error"
        v-model.trim.lazy="$v.promotion_id.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.promotion_id" :name="$t('ui.promotion_id')")
    b-form-group(:label="$t('ui.promotion_name')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="promotion_name"
        required
        type="text"
        :dirty="$v.promotion_name.$dirty"
        :error="$v.promotion_name.$error"
        v-model.trim.lazy="$v.promotion_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.promotion_name" :name="$t('ui.promotion_name')")
    b-form-group(:label="$t('ui.payment_option')" style="overflow: hidden scroll; height: 25vh;").mb-0
      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
        thead.thead-light
          tr
            th.text-center.col-checkbox(width="5%")
              .custom-checkbox.custom-control
                input#all-provider.custom-control-input(type='checkbox' data-checkboxes="allSelectedPO" data-checkbox-role="dad" @click="selectAllPO" v-model="allSelectedPO" :disabled="loading")
                label.custom-control-label(for='all-provider') &nbsp;
            th
              span.font-weight-bold {{ allSelectedPO  ? $t('ui.unselect_all') : $t('ui.select_all') }}
        tbody
          tr(v-for='(p, index) in paymentOptionList')
            td.text-center.col-checkbox
              .custom-checkbox.custom-control
                input.custom-control-input(:id="'all-' + index" type='checkbox' v-model="payment_option_list" :value='p.value' :disabled="loading")
                label.custom-control-label(:for="'all-' + index") &nbsp;
            td {{ p.text }}
      ValidateResult(:value="$v.payment_option_list" :name="$t('ui.payment_option')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const atLeastOnePaymentOption = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      promotion_id: "",
      promotion_name: "",
      payment_option_list: [],
      paymentOptionList: [],
      allSelectedPO: false
    };
  },
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    }
  },
  validations: {
    promotion_id: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    promotion_name: {
      required,
      // minLength: minLength(6),
      maxLength: maxLength(100)
    },
    payment_option_list: {
      atLeastOnePaymentOption,
      minLength: minLength(1)
    },
  },
  watch : {
    payment_option_list(newValue, oldValue) {
      if (newValue.length === 0)
        this.allSelectedPO = false;
      else if (newValue.length === this.paymentOptionList.length)
        this.allSelectedPO = true;
      else
        this.allSelectedPO = false;
    }
  },
  methods: {
    selectAllPO: function() {
      this.payment_option_list = [];

      let list = this.paymentOptionList;

      if (!this.allSelectedPO) {
        for(var i = 0; i < list.length; i++) {
          this.payment_option_list.push(list[i].value);
        }
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.promotionVoucherUpdatePaymentOptionUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          promotion_id: this.promotion_id
        };

        if (this.payment_option_list.length != this.paymentOptionList.length)
          json.payment_option_list = this.removeDuplicate(this.payment_option_list.sort()).toString();

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editPromoVoucherPaymentOption.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_promo_voucher_payment_option", this.feedback.status);
                  this.$refs.editPromoVoucherPaymentOption.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    getPaymentOptionList: function() {
      let url = config.paymentOptionGlobalListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = response.data.dt;
                if(list.length > 0) {
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].payment_mode.toUpperCase(), text: list[i].payment_desc, checked: false});
                  }
                  this.paymentOptionList = result;

                  if (this.payment_option_list == null || this.payment_option_list.length == 0)
                    this.payment_option_list = this.paymentOptionList.map(a => a.value);
                } else {
                  this.paymentOptionList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.paymentOptionList = [];
      this.allSelectedPO = false;
      this.promotion_id = this.item.promotion_id;
      this.promotion_name = this.item.promotion_name;
      this.payment_option_list =  this.item.payment_option_list != null ? this.item.payment_option_list.toUpperCase().split(',') : [];
      this.getPaymentOptionList();
    }
  }
};
</script>
